import React from 'react'
import { Button } from 'spa/member/components/v2/Button'
import styles from './FaqList.module.scss'
import { Accordion } from 'spa/member/components/Accordion'
import { useIsMobile } from 'spa/member/hooks/v2/useScreenSize'
import { BlockContainer } from 'spa/member/components/Top/BlockContainer'
import FaqList from './faq.json'
import { faqJsonLd } from './constants/jsonLd'

export const StyledFaqList: React.FC = () => {
  const isMobile = useIsMobile()
  const sectionDescription = () => {
    return isMobile
      ? ['クラウドワークス テックについて、', 'よくご質問いただく内容をまとめました。']
      : ['クラウドワークス テックについて、よくご質問いただく内容をまとめました。']
  }

  return (
    <BlockContainer title='登録前によくある質問' text={sectionDescription()} className={`${styles.blockContainer}`}>
      <section className="flex flex-col w-full all:flex-wrap desktop:flex-nowrap">
        {FaqList.map((faq, index) => (
          <Accordion
            key={index}
            title={faq.title}
            size={isMobile ? 'small' : 'default'}
            className={`bg-member-gray-0 ${styles.accordion}`}
          >
            {faq.answer.map((line, index) => (
              <React.Fragment key={index}>
                {line}
                {index < faq.answer.length - 1 && <br />}
              </React.Fragment>
            ))}
          </Accordion>
        ))}
        <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      </section>
      <section className="flex flex-col all:pt-L tablet:pt-2XL desktop:pt-2XL items-center">
        <a href="/faq">
          <Button buttonType={isMobile ? 'SMALL' : 'DEFAULT'} link>よくある質問一覧を見る</Button>
        </a>
      </section>
    </BlockContainer>
  )
}
